import React, { useState } from 'react'
import Navbar from '../components/Navbar'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import { InfoContainer3, InfoWrapper, InfoRow, Column1, TextWrapper, TopLine, Heading, Subtitle, BtnWrap, Column2, ImgWrap, Img, ImgRound, Tile, TilesContainer } from '../components/InfoSection/InfoElements'

const Edu = () => {
    const [isOpen, setIsOpen] = useState(false)

    const toggle = () => {
        setIsOpen(!isOpen)
    }

  return (
    <>
    <Navbar toggle={toggle} />
    <Sidebar isOpen={isOpen} toggle={toggle} />
    <InfoContainer3 lightBg='true'>
                <InfoWrapper>
                  <div>
                    Edukacja
                  </div>
                </InfoWrapper>
    </InfoContainer3>
    <Footer />
    </>
  )
}

export default Edu